import { useState, useEffect } from "react";
import { LIB_STORAGE_BOARD_SUBMISSION_STATUS } from "../../../hooks/useBoardForm";
import SnackbarMessage from "../../atoms/Snackbar";

const BoardSnackbarMessage = () => {
  const [snackbarInfor, setSnackbarInfor] = useState<any>({
    severity: "",
    message: "",
  });
  const handleClose = () => {
    localStorage.removeItem(LIB_STORAGE_BOARD_SUBMISSION_STATUS);
    setSnackbarInfor({
      severity: "",
      message: "",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const savedBoardSubmissionStatus = localStorage.getItem(
      LIB_STORAGE_BOARD_SUBMISSION_STATUS
    );

    if (savedBoardSubmissionStatus) {
      const parseBoardSubmissionStatus =
        JSON.parse(savedBoardSubmissionStatus) ?? {};
      if (parseBoardSubmissionStatus) {
        setSnackbarInfor({
          severity: parseBoardSubmissionStatus?.severity ?? "",
          message: parseBoardSubmissionStatus?.message ?? "",
        });
      }
    }
  }, []);

  return (
    <SnackbarMessage
      {...snackbarInfor}
      open={!!snackbarInfor?.message}
      handleClose={handleClose}
    />
  );
};

export default BoardSnackbarMessage;
